// Shared styles
const centerText = {
  textAlign: 'center' as 'center'
}

const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const buttonReset = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer'
}

export default (theme: any) => ({
  wrapper: {
    padding: '30px 40px',
    minWidth: 600,
    '@media (max-width: 768px)': {
      padding: '20px 25px',
      minWidth: 'auto'
    }
  },

  innerWrapper: {
    borderBottom: '1px solid #d8dbe0',
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'column' as 'column'
  },

  crossButton: {
    ...buttonReset,
    alignSelf: 'flex-end',
    minWidth: 'auto',
    '&:hover': {
      background: 'none'
    }
  },

  welcomeMessageTitle: {
    ...centerText,
    color: '#94969a',
    fontSize: 18
  },

  userName: {
    ...centerText,
    color: '#323335',
    fontSize: 18,
    marginBottom: 10
  },

  userDetailsWrapper: {
    marginTop: 30
  },

  nonEditableText: {
    ...centerText,
    color: '#323335',
    fontSize: 14,
    marginBottom: 25
  },

  uploadPictureButton: {
    ...centerText,
    width: 130,
    padding: 8,
    fontSize: 14,
    color: theme.palette.primary.main,
    borderRadius: 40,
    border: `1px solid ${theme.palette.primary.main}`,
    margin: '25px auto 0',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: theme.palette.primary.main,
      color: '#fff'
    }
  },

  saveBtn: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: 40,
    fontSize: 14,
    padding: '10px 30px',
    margin: '30px 0 0 auto',
    transition: 'opacity 0.2s ease',
    '&:hover:not(:disabled)': {
      opacity: 0.9
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed'
    }
  },

  error: {
    background: '#ef5350',
    color: '#fff'
  },

  inputRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 35,
    rowGap: 20,
    marginBottom: 20,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
      gap: 20
    }
  },

  inputRowSingle: {
    marginBottom: 20
  },

  userDetailTitle: {
    color: '#94969a',
    fontSize: 14,
    marginBottom: 8
  },

  inputField: {
    border: '1px solid #d8dbe0',
    borderRadius: 40,
    padding: '7px 15px',
    fontSize: 14,
    transition: 'all 0.2s ease',
    boxSizing: 'border-box' as 'border-box',
    '&:hover': {
      borderColor: '#b0b3b8'
    },
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`
    }
  },

  profilePictureDefault: {
    width: 130,
    height: 130,
    margin: '10px auto',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.main}`,
    overflow: 'hidden',
    ...centerText,
    position: 'relative' as 'relative',
    '&:hover $clearImg': {
      display: 'flex'
    }
  },

  clearImg: {
    ...buttonReset,
    ...flexCenter,
    position: 'absolute' as 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 90,
    minWidth: 'auto',
    color: '#fff',
    background: 'rgba(0,0,0,0.8)',
    padding: '4px 8px',
    display: 'none',
    borderRadius: 4,
    transition: 'background 0.2s ease',
    textTransform: 'none' as 'none',
    '&:hover': {
      background: 'rgba(0,0,0,0.9)'
    }
  },

  profilePicText: {
    color: theme.palette.primary.main,
    fontSize: 48,
    lineHeight: '130px'
  }
})
